module.exports = __webpack_public_path__ + "media/images/home-page/3-1@2x-193a1177d901073ee728ab4fa6068cac.png";